import { Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';


@Injectable({
    providedIn: 'root'
})
export class PixelService {

    private renderer: Renderer2;
    private doc: Document;
    private isBrowser: Boolean;

    constructor(
                @Inject(PLATFORM_ID) private platformId: Object,
                @Inject(DOCUMENT) private injectedDocument: any,
                rendererFactory: RendererFactory2) {

        this.isBrowser = isPlatformBrowser(this.platformId);
        this.doc = this.injectedDocument as Document;
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    init(pixelId: string) {
        const pixelCode = `
                   var pixelCode = function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${pixelId}');`;

        const scriptElement = this.renderer.createElement('script');
        this.renderer.setAttribute(scriptElement, 'id', 'pixel-script');
        this.renderer.setAttribute(scriptElement, 'type', 'text/javascript');
        this.renderer.setProperty(scriptElement, 'innerHTML', pixelCode);
        this.renderer.appendChild(this.doc.head, scriptElement);
    }

    stop() {
        if (!this.isBrowser) {
            return;
        }
        const pixelElement = this.doc.getElementById('pixel-script');
        if (pixelElement) {
            pixelElement.remove();
        }
    }
}
